export default __webpack_public_path__ + "static/media/logo-pink.44ed61fa.png";